<template>
  <Container>
    <template #header>
      <HeaderFe />
    </template>
    <template v-slot:default>
      <main>
        <section class="pb-10">
          <div class="max-w-[1170px] mx-auto px-4 sm:px-8 xl:px-0">
            <h2 class="mt-8 mb-6 font-semibold text-heading-5 text-dark">
              Grafik Data Mahasiswa
            </h2>

            <!-- Filter Section -->
            <div class="bg-white rounded-lg shadow-md p-6 mb-8">
              <h3 class="text-lg font-semibold mb-4">Filter Data</h3>
              <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div>
                  <label class="block text-sm font-medium text-gray-700 mb-2">
                    Tahun Akademik
                  </label>
                  <select
                    v-model="selectedTahunAkademik"
                    @change="updateChart"
                    class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <option value="">Semua Tahun</option>
                    <option
                      v-for="tahun in tahunAkademikList"
                      :key="tahun"
                      :value="tahun"
                    >
                      {{ tahun }}
                    </option>
                  </select>
                </div>

                <div>
                  <label class="block text-sm font-medium text-gray-700 mb-2">
                    Semester
                  </label>
                  <select
                    v-model="selectedSemester"
                    @change="updateChart"
                    class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <option value="">Semua Semester</option>
                    <option value="ganjil">Ganjil</option>
                    <option value="genap">Genap</option>
                  </select>
                </div>

                <div>
                  <label class="block text-sm font-medium text-gray-700 mb-2">
                    Program Studi
                  </label>
                  <select
                    v-model="selectedProdi"
                    @change="updateChart"
                    class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <option value="">Semua Program Studi</option>
                    <option
                      v-for="prodi in prodiList"
                      :key="prodi.kode_prodi"
                      :value="prodi.kode_prodi"
                    >
                      {{ prodi.nama_prodi }}
                    </option>
                  </select>
                </div>
              </div>
            </div>

            <!-- Statistics Cards -->
            <div class="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
              <div
                class="bg-gradient-to-r from-blue-500 to-blue-600 rounded-lg p-6 text-white"
              >
                <div class="flex items-center justify-between">
                  <div>
                    <p class="text-blue-100 text-sm font-medium">
                      Total Mahasiswa
                    </p>
                    <p class="text-2xl font-bold">
                      {{ totalMahasiswa.toLocaleString() }}
                    </p>
                  </div>
                  <div class="bg-white bg-opacity-20 rounded-lg p-3">
                    <svg
                      class="w-8 h-8"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                      ></path>
                    </svg>
                  </div>
                </div>
              </div>

              <div
                class="bg-gradient-to-r from-green-500 to-green-600 rounded-lg p-6 text-white"
              >
                <div class="flex items-center justify-between">
                  <div>
                    <p class="text-green-100 text-sm font-medium">
                      Total Program Studi
                    </p>
                    <p class="text-2xl font-bold">{{ totalProdi }}</p>
                  </div>
                  <div class="bg-white bg-opacity-20 rounded-lg p-3">
                    <svg
                      class="w-8 h-8"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        d="M3 4a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1V4zM3 10a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H4a1 1 0 01-1-1v-6zM14 9a1 1 0 00-1 1v6a1 1 0 001 1h2a1 1 0 001-1v-6a1 1 0 00-1-1h-2z"
                      ></path>
                    </svg>
                  </div>
                </div>
              </div>

              <div
                class="bg-gradient-to-r from-purple-500 to-purple-600 rounded-lg p-6 text-white"
              >
                <div class="flex items-center justify-between">
                  <div>
                    <p class="text-purple-100 text-sm font-medium">
                      Rata-rata per Prodi
                    </p>
                    <p class="text-2xl font-bold">
                      {{ averagePerProdi.toLocaleString() }}
                    </p>
                  </div>
                  <div class="bg-white bg-opacity-20 rounded-lg p-3">
                    <svg
                      class="w-8 h-8"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M3 3a1 1 0 000 2v8a2 2 0 002 2h2.586l-1.293 1.293a1 1 0 101.414 1.414L10 15.414l2.293 2.293a1 1 0 001.414-1.414L12.414 15H15a2 2 0 002-2V5a1 1 0 100-2H3zm11.707 4.707a1 1 0 00-1.414-1.414L10 9.586 8.707 8.293a1 1 0 00-1.414 0l-2 2a1 1 0 101.414 1.414L8 10.414l1.293 1.293a1 1 0 001.414 0l4-4z"
                        clip-rule="evenodd"
                      ></path>
                    </svg>
                  </div>
                </div>
              </div>
            </div>

            <!-- Chart Section -->
            <div class="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-8">
              <!-- Bar Chart -->
              <div class="bg-white rounded-lg shadow-md p-6">
                <h3 class="text-lg font-semibold mb-4">Grafik Batang</h3>
                <div class="h-80">
                  <canvas ref="barChart"></canvas>
                </div>
              </div>

              <!-- Pie Chart -->
              <div class="bg-white rounded-lg shadow-md p-6">
                <h3 class="text-lg font-semibold mb-4">Grafik Lingkaran</h3>
                <div class="h-80">
                  <canvas ref="pieChart"></canvas>
                </div>
              </div>
            </div>

            <!-- Data Table -->
            <div class="bg-white rounded-lg shadow-md overflow-hidden">
              <div class="px-6 py-4 border-b border-gray-200">
                <h3 class="text-lg font-semibold">Detail Data Mahasiswa</h3>
              </div>
              <div class="overflow-x-auto">
                <table class="min-w-full divide-y divide-gray-200">
                  <thead class="bg-gray-50">
                    <tr>
                      <th
                        class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                      >
                        Program Studi
                      </th>
                      <th
                        class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                      >
                        Kode Prodi
                      </th>
                      <th
                        class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                      >
                        Jumlah Mahasiswa
                      </th>
                      <th
                        class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                      >
                        Persentase
                      </th>
                    </tr>
                  </thead>
                  <tbody class="bg-white divide-y divide-gray-200">
                    <tr
                      v-for="item in chartData"
                      :key="item.kode_prodi"
                      class="hover:bg-gray-50"
                    >
                      <td
                        class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                      >
                        {{ item.nama_prodi }}
                      </td>
                      <td
                        class="px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                      >
                        {{ item.kode_prodi }}
                      </td>
                      <td
                        class="px-6 py-4 whitespace-nowrap text-sm text-gray-900"
                      >
                        {{ item.total_mahasiswa.toLocaleString() }}
                      </td>
                      <td
                        class="px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                      >
                        {{ getPercentage(item.total_mahasiswa) }}%
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- Empty State -->
              <div v-if="chartData.length === 0" class="text-center py-12">
                <svg
                  class="mx-auto h-12 w-12 text-gray-400"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
                  />
                </svg>
                <h3 class="mt-2 text-sm font-medium text-gray-900">
                  Tidak ada data
                </h3>
                <p class="mt-1 text-sm text-gray-500">
                  Tidak ada data mahasiswa yang sesuai dengan filter yang
                  dipilih.
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>
    </template>
    <template #footer>
      <FooterFe />
    </template>
  </Container>
</template>

<script setup>
import { ref, computed, onMounted, nextTick } from "vue";
import Container from "@/Layouts/Container.vue";
import HeaderFe from "@/Components/HeaderFe.vue";
import FooterFe from "@/Components/FooterFe.vue";
import { Chart, registerables } from "chart.js";

Chart.register(...registerables);

// Props
const props = defineProps({
  tahunAkademikList: Array,
  prodiList: Array,
  initialChartData: Array,
});

// Reactive data
const selectedTahunAkademik = ref("");
const selectedSemester = ref("");
const selectedProdi = ref("");
const chartData = ref(props.initialChartData || []);
const barChart = ref(null);
const pieChart = ref(null);
const barChartInstance = ref(null);
const pieChartInstance = ref(null);

// Computed properties
const totalMahasiswa = computed(() => {
  return chartData.value.reduce(
    (total, item) => total + item.total_mahasiswa,
    0
  );
});

const totalProdi = computed(() => {
  return chartData.value.length;
});

const averagePerProdi = computed(() => {
  if (totalProdi.value === 0) return 0;
  return Math.round(totalMahasiswa.value / totalProdi.value);
});

// Methods
const getPercentage = (value) => {
  if (totalMahasiswa.value === 0) return 0;
  return ((value / totalMahasiswa.value) * 100).toFixed(1);
};

const updateChart = async () => {
  try {
    const params = new URLSearchParams();
    if (selectedTahunAkademik.value)
      params.append("tahun_akademik", selectedTahunAkademik.value);
    if (selectedSemester.value)
      params.append("semester", selectedSemester.value);
    if (selectedProdi.value) params.append("kode_prodi", selectedProdi.value);

    const response = await fetch(`/grafik-chart-data?${params.toString()}`);
    const data = await response.json();

    chartData.value = data.data || [];

    await nextTick();
    renderCharts();
  } catch (error) {
    console.error("Error updating chart:", error);
  }
};

const renderCharts = () => {
  renderBarChart();
  renderPieChart();
};

const renderBarChart = () => {
  if (barChartInstance.value) {
    barChartInstance.value.destroy();
  }

  const ctx = barChart.value.getContext("2d");
  const labels = chartData.value.map((item) => item.nama_prodi);
  const data = chartData.value.map((item) => item.total_mahasiswa);

  barChartInstance.value = new Chart(ctx, {
    type: "bar",
    data: {
      labels: labels,
      datasets: [
        {
          label: "Jumlah Mahasiswa",
          data: data,
          backgroundColor: "rgba(59, 130, 246, 0.8)",
          borderColor: "rgba(59, 130, 246, 1)",
          borderWidth: 1,
        },
      ],
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        y: {
          beginAtZero: true,
          ticks: {
            stepSize: 1,
          },
        },
        x: {
          ticks: {
            maxRotation: 45,
            minRotation: 45,
          },
        },
      },
      plugins: {
        legend: {
          display: false,
        },
        tooltip: {
          callbacks: {
            label: function (context) {
              return `Jumlah: ${context.raw.toLocaleString()} mahasiswa`;
            },
          },
        },
      },
    },
  });
};

const renderPieChart = () => {
  if (pieChartInstance.value) {
    pieChartInstance.value.destroy();
  }

  const ctx = pieChart.value.getContext("2d");
  const labels = chartData.value.map((item) => item.nama_prodi);
  const data = chartData.value.map((item) => item.total_mahasiswa);

  // Generate colors
  const colors = [
    "#EF4444",
    "#F97316",
    "#EAB308",
    "#22C55E",
    "#06B6D4",
    "#3B82F6",
    "#8B5CF6",
    "#EC4899",
    "#F59E0B",
    "#10B981",
    "#6366F1",
    "#84CC16",
    "#F472B6",
    "#14B8A6",
    "#A855F7",
  ];

  pieChartInstance.value = new Chart(ctx, {
    type: "pie",
    data: {
      labels: labels,
      datasets: [
        {
          data: data,
          backgroundColor: colors.slice(0, data.length),
          borderColor: "#ffffff",
          borderWidth: 2,
        },
      ],
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          position: "bottom",
          labels: {
            padding: 20,
            usePointStyle: true,
          },
        },
        tooltip: {
          callbacks: {
            label: function (context) {
              const total = context.dataset.data.reduce((a, b) => a + b, 0);
              const percentage = ((context.raw / total) * 100).toFixed(1);
              return `${
                context.label
              }: ${context.raw.toLocaleString()} (${percentage}%)`;
            },
          },
        },
      },
    },
  });
};

// Lifecycle
onMounted(async () => {
  await nextTick();
  renderCharts();
});
</script>

<style scoped>
/* Custom styles for consistent frontend layout */
.text-heading-5 {
  font-size: 1.5rem;
  line-height: 2rem;
}

.text-dark {
  color: #1f2937;
}
</style>
